import { request } from "$/lib/api"
import { Route, SelfBillingInvoiceDto, populateRoute } from "@repo/common"
import { queryOptions } from "@tanstack/react-query"

const fetchList = async (storeId: string): Promise<SelfBillingInvoiceDto[]> =>
  request<SelfBillingInvoiceDto[]>({
    url: populateRoute(Route.SELF_BILLING_INVOICE__FIND_MANY_BY_STORE, storeId),
    method: "GET",
  })

export const fetchSelfBillingInvoicePdfBlob = async (
  invoiceId: string,
): Promise<Blob> =>
  request<Blob>({
    url: populateRoute(Route.SELF_BILLING_INVOICE__DOWNLOAD_PDF, invoiceId),
    method: "GET",
    responseType: "blob",
  })

/** Fetches the invoice PDF and triggers a browser download. */
export const downloadSelfBillingInvoicePdf = async (
  invoiceId: string,
  invoiceNumber: string,
): Promise<void> => {
  const blob = await fetchSelfBillingInvoicePdfBlob(invoiceId)
  const objectUrl = URL.createObjectURL(blob)
  try {
    const link = document.createElement("a")
    link.href = objectUrl
    link.download = `sjalvfaktura-${invoiceNumber}.pdf`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } finally {
    URL.revokeObjectURL(objectUrl)
  }
}

const selfBillingInvoiceQueries = {
  all: () => ["selfBillingInvoice"],
  lists: () => [...selfBillingInvoiceQueries.all(), "list"],
  list: (storeId: string) =>
    queryOptions({
      queryKey: [...selfBillingInvoiceQueries.lists(), storeId],
      queryFn: () => fetchList(storeId),
    }),
}

export default selfBillingInvoiceQueries
